export const certificates = [
    {
        id: 1,
        name: 'Complete course on Javascript + React',
        issuingOrganization: 'Udemy',
        credentialId: 'UC-268700fb-f379-499e-8cee-dedb4a179b85',
        credentialURL: 'https://www.udemy.com/certificate/UC-268700fb-f379-499e-8cee-dedb4a179b85/',
        img: '/images/educationCertificates/React.jpg',
        skills: [
            'JavaScript',
            'React'
        ]
    }
];